import { useMutation } from '@tanstack/react-query';
import { GET, GET_ME } from '../../../services';

export const useGetMe = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ lineUid, branchId }) => {
      const response = await GET(GET_ME(lineUid, branchId));
      return response;
    },
  });

  return {
    mutate,
    isPending,
  };
};
